import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import layout components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Import pages
import Home from './pages/Home';
import Services from './pages/Services';
import TravelMarketingService from './pages/TravelMarketingService';
import TourismDevelopmentService from './pages/TourismDevelopmentService';
import DigitalToolsService from './pages/DigitalToolsService';
import TradeShowSupport from './pages/TradeShowSupport';
import MonthlyMarketingSupport from './pages/MonthlyMarketingSupport';
import Projects from './pages/LabResults';
import CaseStudyDetail from './pages/CaseStudyDetail';
import Tools from './pages/Tools';
import TravelBrandGenerator from './pages/TravelBrandGenerator';
import TourismSentimentAnalyzer from './pages/TourismSentimentAnalyzer';
import About from './pages/About';
import Contact from './pages/Contact';

// Blog pages
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import BlogCategory from './pages/BlogCategory';

// Admin pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import PostList from './pages/admin/PostList';
import PostEditor from './pages/admin/PostEditor';
import CategoryList from './pages/admin/CategoryList';
import CategoryEditor from './pages/admin/CategoryEditor';

// Auth components
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/travel-marketing" element={<TravelMarketingService />} />
              <Route path="/services/tourism-development" element={<TourismDevelopmentService />} />
              <Route path="/services/digital-tools" element={<DigitalToolsService />} />
              <Route path="/services/trade-show-support" element={<TradeShowSupport />} />
              <Route path="/services/monthly-marketing-support" element={<MonthlyMarketingSupport />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<CaseStudyDetail />} />
              <Route path="/tools" element={<Tools />} />
              <Route path="/tools/travel-brand-generator" element={<TravelBrandGenerator />} />
              <Route path="/tools/tourism-sentiment-analyzer" element={<TourismSentimentAnalyzer />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              
              {/* Blog Routes */}
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/blog/category/:categoryId" element={<BlogCategory />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              
              {/* Protected Admin Routes */}
              <Route element={<PrivateRoute />}>
                <Route path="/admin/dashboard" element={<Dashboard />} />
                <Route path="/admin/posts" element={<PostList />} />
                <Route path="/admin/posts/new" element={<PostEditor />} />
                <Route path="/admin/posts/edit/:id" element={<PostEditor />} />
                <Route path="/admin/categories" element={<CategoryList />} />
                <Route path="/admin/categories/new" element={<CategoryEditor />} />
                <Route path="/admin/categories/edit/:id" element={<CategoryEditor />} />
              </Route>
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;